import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { MobileNav } from './MobileNav';
import type { Role } from '@/types/domain';

// Demo role — in production this comes from the authenticated session/profile.
const DEMO_ROLE: Role = 'admin';

/** Responsive app shell: glass sidebar (desktop) + bottom nav (mobile). */
export function AppShell() {
  return (
    <div className="flex min-h-dvh">
      <Sidebar role={DEMO_ROLE} />
      <div className="flex min-w-0 flex-1 flex-col pb-20 lg:pb-0">
        <Topbar />
        <main className="flex-1 px-4 pb-8 lg:px-6">
          <Outlet />
        </main>
      </div>
      <MobileNav role={DEMO_ROLE} />
    </div>
  );
}
